import { makeStyles } from "src/makeStyles";

const useStyles = makeStyles()((theme) => ({
  main: {
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("lg")]: {
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  root: {
    [theme.breakpoints.down("lg")]: {
      top: "0 !important",
      transform: "translateY(10%)",
      backgroundColor: theme.palette.background.default
    },
    [theme.breakpoints.down("md")]: {
      transform: "translateY(10%)"
    },
    maxWidth: "1045px",
    padding: "0",
    backgroundColor: `${theme.logoBackground}66`, // 66 represents transparency for hex
    borderRadius: "10px",
    height: "500px"
  },
  containerFormInterior: {
    display: "flex",
    width: "332px",
    margin: "0 auto",
    marginTop: "20px"
  },
  checkCircle: {
    color: theme.checkCircle,
    width: "75px",
    height: "75px",
    marginBottom: "10px",
    marginTop: "40px"
  },
  linkBack: {
    textAlign: "center",
    textTransform: "none",
    color: theme.palette.primary.contrastText,
    marginTop: "10px",
    textDecoration: "none",
    display: "inline-flex"
  },
  form: {
    width: "100%"
  },
  innerGrid: {
    marginTop: "2rem"
  },
  wrappImages: {
    display: "block",
    width: "545px",
    height: "500px"
  },
  imageLogo: {
    [theme.breakpoints.down("lg")]: {
      width: "486px",
      margin: "0 auto auto"
    },
    [theme.breakpoints.down("md")]: {
      width: "360px",
      marginTop: 0
    },
    [theme.breakpoints.down("sm")]: {
      width: "280px"
    },
    width: "344px",
    margin: "147px auto auto",
    display: "block"
  },
  imageClickIcon: {
    [theme.breakpoints.down("lg")]: {
      width: "110px",
      margin: "82px auto 82px auto"
    },
    [theme.breakpoints.down("md")]: {
      width: "100px",
      margin: "62px auto 62px auto"
    },
    [theme.breakpoints.down("sm")]: {
      width: "80px",
      margin: "32px auto 32px auto"
    },
    color: theme.clickIconColor,
    width: "100px",
    height: "100px",
    margin: "62px auto auto",
    display: "block"
  },
  forgotButton: {
    padding: "10px 20px",
    width: "100%",
    height: "36px",
    background: theme.palette.primary.contrastText,
    borderRadius: "4px",
    alignItems: "center",
    textAlign: "center",
    textTransform: "uppercase",
    marginTop: "30px"
  },
  forgotPaper: {
    borderRadius: "0 10px 10px 0",
    width: "100%",
    boxShadow: "none"
  },
  containerForm: {
    [theme.breakpoints.down("lg")]: {
      borderRadius: "10px",
      width: "70%"
    },
    [theme.breakpoints.down("md")]: {
      width: "86%"
    },
    [theme.breakpoints.down("sm")]: {
      borderRadius: "0"
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "500px"
    },
    width: "500px",
    backgroundColor: theme.palette.common.white,
    borderRadius: "0 10px 10px 0",
    padding: "50px 85px",
    height: "500px",
    flexBasis: "unset"
  },
  "@media (max-width: 1279px)": {
    forgotPaper: {
      [theme.breakpoints.down("sm")]: {
        borderRadius: 0
      },
      borderRadius: "10px",
      width: "100%"
    },
    root: {
      width: "100%",
      height: "500px"
    },
    space: {
      [theme.breakpoints.down("lg")]: {
        minWidth: "100%",
        left: 0
      },
      position: "absolute",
      top: "0",
      left: "10%",
      transform: "initial",
      minWidth: "80%",
      borderRadius: "0"
    }
  },
  "@media (max-width: 768px)": {
    space: {
      position: "absolute",
      top: "0",
      left: "0",
      transform: "initial",
      borderRadius: "0"
    }
  },
  outerGrid: {
    padding: "2rem",
    [theme.breakpoints.up("sm")]: {
      padding: "37px 0 47px 0"
    },
    gap: "5px"

  },
  spinner: {
    color: theme.palette.common.white
  },
  titlesContainer: {
    width: "314px"
  },
  backIcon: {
    width: "16px",
    marginRight: "10px",
    paddingTop: "5px",
    color: theme.palette.primary.contrastText
  },
  containerImage: {
    [theme.breakpoints.up("lg")]: {
      maxWidth: "545px"
    }
  }
}));

export default useStyles;
